import { ComponentStyleConfig, theme as chakraTheme } from '@chakra-ui/react'

const { baseStyle } = chakraTheme.components.Tooltip

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    bg: 'neutral.90',
    borderRadius: 'base',
    boxShadow: 'md',
    color: 'white',
  },
  defaultProps: {
    variant: 'solid',
  },
  variants: {
    solid: () => ({
      ...baseStyle,
      bg: 'neutral.90',
      borderRadius: 'base',
      boxShadow: 'md',
      color: 'white',
    }),
  },
}
